import React from 'react';
import styles from './panel.module.sass';
import cx from 'classnames';

const Panel = (props) => {
  let { bgcolor, className } = props;

  return (
    <div
      className={cx(styles.panel, className)}
      style={bgcolor ? { backgroundColor: bgcolor } : null}
    >
      {props.children}
    </div>
  );
};

export default Panel;
